module.exports = __webpack_public_path__ + "static/media/painting.b866ef19.png";